import { Grid, Cell, Icon, Field, Button } from '@teamsnap/teamsnap-ui';
import { validInteger } from 'core';
import * as React from 'react';

export interface Props {
  isDisabled: boolean;
  search: Function;
  searching: boolean,
  setSearching: Function;
  buttonName?: string;
  errorMessage: string;
  setErrorMessage: Function;
  defaultLabel?: string;
}

const OrgAdminSearchField: React.FunctionComponent<Props> = ({
  isDisabled,
  searching,
  setSearching,
  search,
  setErrorMessage,
  buttonName,
  errorMessage,
  defaultLabel
}) => {
  const [searchUUID, setSearchUUID] = React.useState('');
  const [hasError, setHasError] = React.useState(false);

  const onChange = ({ target: { value } }) => {
    if(value == '' || validInteger(value)) {
      setSearchUUID(value);
    }
    setErrorMessage(null);
    setHasError(false);
  };

  const onSearch = () => {
    setHasError(false);
    setSearching(true);
    setErrorMessage(null);
    if (searchUUID.length <= 0) {
      setHasError(true);
      return;
    }
    search(searchUUID);
  };


  return (
    <Grid isWithGutter={true}>
      <Cell mods="u-size12of12">
        <div className="u-flex">
          <Field
            type="input"
            name="UUID"
            status={hasError ? 'error' : 'success'}
            formFieldProps={{
              placeholder: defaultLabel,
              leftIcon: <Icon className="Icon" name="search" />,
              inputProps: {
                type: 'text',
                onChange: onChange,
                id: 'uuidSearchInput',
                value: searchUUID,
                disabled: isDisabled || searching,
                'data-testid': 'uuidSearchInput'
              },
            }}
          />
          <Button
            mods="u-spaceRightSm u-spaceLeftSm"
            color="primary"
            type="button"
            isDisabled={isDisabled || searching}
            onClick={onSearch}
          >
            {buttonName}
          </Button>
          {searching && (<div className="u-spaceTopSm">Searching for {searchUUID}.</div>)}
          {errorMessage && <div className="u-spaceTopSm u-colorNegative">{errorMessage}</div>}
        </div>
      </Cell>
    </Grid>
  );
};

OrgAdminSearchField.defaultProps = {
  buttonName: 'Search',
  defaultLabel: 'UUID'
};

export default OrgAdminSearchField;
